// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/MrEavesXLModOT-Reg.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/MrEavesXLModOT-Reg.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/MrEavesXLModOT-Reg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/MrEavesXLModOT-Reg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/MrEavesXLModOT-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/MrEavesXLModOT-Book.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/MrEavesXLModOT-Book.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/MrEavesXLModOT-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/MrEavesXLModOT-Book.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/MrEavesXLModOT-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/MrEavesXLModOT-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/MrEavesXLModOT-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/MrEavesXLModOT-Bold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "mreaves-regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "mreaves-light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "mreaves-book";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "mreaves-bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
h1 {
  font-size: 28px;
  line-height: 28px;
}

ml-0 {
  margin-left: 0px !important;
}

h2 {
  font-size: 25px;
  line-height: 25px;
}

h3 {
  font-size: 22px;
  line-height: 22px;
}

h4 {
  font-size: 19px;
  line-height: 19px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

h5 {
  font-size: 16px;
  line-height: 16px;
}

a {
  color: #5673f8;
}

.error {
  color: red;
}

.warning {
  color: orange;
}

.success {
  color: green;
}

.red_colour {
  color: red;
  font-weight: bold;
}

.align-center {
  text-align: center;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: left;
}

.bold_font {
  font-weight: bold;
}

.status_coloured_box {
  width: 15px;
  height: 15px;
  border-radius: 10px;
  float: left;
  margin-right: 10px;
  margin-top: 2px;
}
.status_coloured_box.new-order {
  background-color: #ffffff;
}
.status_coloured_box.order-in-process {
  background-color: #ffffff;
}
.status_coloured_box.order-ready {
  background-color: #69c43b;
}
.status_coloured_box.collected-shipped {
  background-color: #3d7223;
}
.status_coloured_box.waiting-on-deposit-payment {
  background-color: #b8b8b8;
}
.status_coloured_box.order-on-hold {
  background-color: #6d82c1;
}
.status_coloured_box.pending-change-update {
  background-color: #6d82c1;
}
.status_coloured_box.cancelled {
  background-color: #bd4442;
}
.status_coloured_box.returned {
  background-color: #bd4442;
}
.status_coloured_box.follow-up-remaking-fixing {
  background-color: #dfa4a3;
}
.status_coloured_box.ready-internal-transit {
  background-color: #86ad10;
}
.status_coloured_box.ready-to-be-shipped {
  background-color: #f39c12;
}
.status_coloured_box.awaiting-collection-to-send {
  background-color: #f1948a;
}
.status_coloured_box.waiting-on-deposit {
  background-color: #7f8c8d;
}
.status_coloured_box.pending-change-update {
  background-color: #5293f5;
}
.status_coloured_box.in-process {
  background-color: #fff;
}
.status_coloured_box.in-process-standard {
  position: absolute;
}
.status_coloured_box.collected-sent {
  background-color: #229954;
}
.status_coloured_box.in-process-express {
  background-color: #f1c40f;
}
.status_coloured_box.decided_to_buy {
  background-color: #229954;
}
.status_coloured_box.decided_not_to_buy {
  background-color: #5293f5;
}
.status_coloured_box.following_up {
  background-color: #f1c40f;
}

a .button_link {
  background-color: #5673f8;
  display: inline-block;
  color: #fff;
  text-align: center;
  padding: 8px 8px;
  font-size: 12px;
  line-height: 14px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin-left: 5px;
}

.App {
  width: 100%;
  background-color: #fcfeff;
}

.main_menu {
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-height: 18px;
  background-color: #e2f0cb;
  color: black;
}
.main_menu a {
  color: #ff9aa2;
}
.main_menu a h3 {
  margin-top: 6px;
}
.main_menu .links_list {
  width: 20%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  margin-bottom: 0px;
  padding-top: 0px;
}

#LoadingLayer_component {
  width: 100%;
  height: 100%;
  background-color: rgba(222, 222, 222, 0.3);
  position: absolute;
  z-index: 9999;
  padding-left: calc(50% - 1rem);
  padding-top: 400px;
}

#LoginLoadingLayer_component {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9999;
  padding-left: calc(50% - 1rem);
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #9d9d9d;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e3b5bb;
  border-radius: 10px;
}

#WebSocket_component {
  position: absolute;
  z-index: 100;
  right: 10px;
  top: 11px;
  width: 140px;
  height: 30px;
  border-radius: 6px;
  text-align: center;
  background-color: #dfa4a3;
  font-size: 15px;
  padding-top: 6px;
  font-family: "mreaves-regular";
}
#WebSocket_component a {
  color: #fff;
  text-decoration: none;
}

#AddFollowUp_component {
  z-index: 100;
  height: 30px;
  border-radius: 6px;
  text-align: center;
  background-color: #dfa4a3;
  font-size: 15px;
  padding-top: 6px;
  font-family: "mreaves-regular";
}
#AddFollowUp_component a {
  color: #fff;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/css/main.scss"],"names":[],"mappings":"AAKA;EACE,8BAAA;EACA,mPACQ;EAIR,mBAAA;EACA,kBAAA;ACRF;ADWA;EACE,4BAAA;EACA,+DAAA;ACTF;ADaA;EACE,2BAAA;EACA,mPACQ;EAIR,mBAAA;EACA,kBAAA;ACfF;ADkBA;EACE,2BAAA;EACA,sPAAA;EAIA,mBAAA;EACA,kBAAA;ACnBF;AATA;EACE,eAAA;EACA,iBAAA;AAWF;;AARA;EACE,2BAAA;AAWF;;AARA;EACE,eAAA;EACA,iBAAA;AAWF;;AARA;EACE,eAAA;EACA,iBAAA;AAWF;;AARA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;AAWF;;AARA;EACE,eAAA;EACA,iBAAA;AAWF;;AARA;EACE,cArCU;AAgDZ;;AARA;EACE,UAAA;AAWF;;AARA;EACE,aAAA;AAWF;;AARA;EACE,YAAA;AAWF;;AARA;EACE,UAAA;EACA,iBAAA;AAWF;;AARA;EACE,kBAAA;AAWF;;AARA;EACE,gBAAA;AAWF;;AARA;EACE,gBAAA;AAWF;;AARA;EACE,iBAAA;AAWF;;AARA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAWF;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AATE;EACE,yBAAA;AAWJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,sBAAA;AAUJ;AARE;EACE,kBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;AARE;EACE,yBAAA;AAUJ;;AANA;EACE,yBAvJU;EAwJV,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AASF;;AANA;EACE,WAAA;EACA,yBAvKiB;AAgLnB;;AANA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAlLY;EAmLZ,YAAA;AASF;AARE;EACE,cAxLU;AAkMd;AATI;EACE,eAAA;AAWN;AARE;EACE,UAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAUJ;;AANA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AASF;;AANA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AASF;;AANA,UAAA;AAEA;EACE,UAAA;EACA,WAAA;AAQF;;AALA,UAAA;AAEA;EACE,iCAAA;EACA,mBAAA;AAOF;;AAJA,WAAA;AAEA;EACE,mBAAA;EACA,mBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBA/OY;EAgPZ,eAAA;EACA,gBAAA;EACA,8BAAA;AAMF;AALE;EACE,WAAA;EACA,qBAAA;AAOJ;;AAHA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBA9PY;EA+PZ,eAAA;EACA,gBAAA;EACA,8BAAA;AAMF;AALE;EACE,WAAA;EACA,qBAAA;AAOJ","sourcesContent":["\n//******************************\n//FONTS\n//******************************\n\n@font-face {\n  font-family: 'mreaves-regular';\n  src:\n          url(\"../fonts/MrEavesXLModOT-Reg.eot\") format(\"embedded-opentype\"),\n          url(\"../fonts/MrEavesXLModOT-Reg.woff\") format(\"woff\"),\n          url(\"../fonts/MrEavesXLModOT-Reg.ttf\") format(\"truetype\"),\n          url(\"../fonts/MrEavesXLModOT-Reg.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"mreaves-light\";\n  src: url(\"../fonts/MrEavesXLModOT-Light.ttf\") format(\"truetype\");\n}\n\n\n@font-face {\n  font-family: 'mreaves-book';\n  src:\n          url(\"../fonts/MrEavesXLModOT-Book.eot\") format(\"embedded-opentype\"),\n          url(\"../fonts/MrEavesXLModOT-Book.woff\") format(\"woff\"),\n          url(\"../fonts/MrEavesXLModOT-Book.ttf\") format(\"truetype\"),\n          url(\"../fonts/MrEavesXLModOT-Book.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'mreaves-bold';\n  src:  url(\"../fonts/MrEavesXLModOT-Bold.eot\") format(\"embedded-opentype\"),\n  url(\"../fonts/MrEavesXLModOT-Bold.woff\") format(\"woff\"),\n  url(\"../fonts/MrEavesXLModOT-Bold.ttf\") format(\"truetype\"),\n  url(\"../fonts/MrEavesXLModOT-Bold.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}","$color_red_1: #ff9aa2;\n$color_red_2: #ffb7b2;\n$color_orange: #ffdac1;\n$color_grass: #e2f0cb;\n$color_green: #b5ead7;\n$color_purlple: #c7ceea;\n$super_light_blue: #fcfeff;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n$pink_novita: #dfa4a3;\n\n@import \"../css/fonts.scss\";\nh1 {\n  font-size: 28px;\n  line-height: 28px;\n}\n\nml-0 {\n  margin-left: 0px !important;\n}\n\nh2 {\n  font-size: 25px;\n  line-height: 25px;\n}\n\nh3 {\n  font-size: 22px;\n  line-height: 22px;\n}\n\nh4 {\n  font-size: 19px;\n  line-height: 19px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n}\n\nh5 {\n  font-size: 16px;\n  line-height: 16px;\n}\n\na {\n  color: $blue_link;\n}\n\n.error {\n  color: red;\n}\n\n.warning {\n  color: orange;\n}\n\n.success {\n  color: green;\n}\n\n.red_colour {\n  color: red;\n  font-weight: bold;\n}\n\n.align-center {\n  text-align: center;\n}\n\n.align-left {\n  text-align: left;\n}\n\n.align-right {\n  text-align: left;\n}\n\n.bold_font {\n  font-weight: bold;\n}\n\n.status_coloured_box {\n  width: 15px;\n  height: 15px;\n  border-radius: 10px;\n  float: left;\n  margin-right: 10px;\n  margin-top: 2px;\n  // border: 1px #000 solid;\n  &.new-order {\n    background-color: #ffffff;\n  }\n  &.order-in-process {\n    background-color: #ffffff;\n  }\n  &.order-ready {\n    background-color: #69c43b;\n  }\n  &.collected-shipped {\n    background-color: #3d7223;\n  }\n  &.waiting-on-deposit-payment {\n    background-color: #b8b8b8;\n  }\n  &.order-on-hold {\n    background-color: #6d82c1;\n  }\n  &.pending-change-update {\n    background-color: #6d82c1;\n  }\n  &.cancelled {\n    background-color: #bd4442;\n  }\n  &.returned {\n    background-color: #bd4442;\n  }\n  &.follow-up-remaking-fixing {\n    background-color: #dfa4a3;\n  }\n  &.ready-internal-transit {\n    background-color: #86ad10;\n  }\n  //legacy\n  &.ready-to-be-shipped {\n    background-color: #f39c12;\n  }\n  &.awaiting-collection-to-send {\n    background-color: #f1948a;\n  }\n  &.waiting-on-deposit {\n    background-color: #7f8c8d;\n  }\n  &.pending-change-update {\n    background-color: #5293f5;\n  }\n  &.in-process {\n    background-color: #fff;\n  }\n  &.in-process-standard {\n    position: absolute;\n  }\n  &.collected-sent {\n    background-color: #229954;\n  }\n  &.in-process-express {\n    background-color: #f1c40f;\n  }\n  &.decided_to_buy {\n    background-color: #229954;\n  }\n  &.decided_not_to_buy {\n    background-color: #5293f5;\n  }\n  &.following_up {\n    background-color: #f1c40f;\n  }\n}\n\na .button_link {\n  background-color: $blue_link;\n  display: inline-block;\n  color: #fff;\n  text-align: center;\n  padding: 8px 8px;\n  font-size: 12px;\n  line-height: 14px;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  margin-left: 5px;\n}\n\n.App {\n  width: 100%;\n  background-color: $super_light_blue;\n}\n\n.main_menu {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  min-height: 18px;\n  background-color: $color_grass;\n  color: black;\n  a {\n    color: $color_red_1;\n    h3 {\n      margin-top: 6px;\n    }\n  }\n  .links_list {\n    width: 20%;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    list-style: none;\n    margin-bottom: 0px;\n    padding-top: 0px;\n  }\n}\n\n#LoadingLayer_component {\n  width: 100%;\n  height: 100%;\n  background-color: rgba(222, 222, 222, 0.3);\n  position: absolute;\n  z-index: 9999;\n  padding-left: calc(50% - 1rem);\n  padding-top: 400px;\n}\n\n#LoginLoadingLayer_component {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 9999;\n  padding-left: calc(50% - 1rem);\n}\n\n/* width */\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n/* Track */\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px #9d9d9d;\n  border-radius: 10px;\n}\n\n/* Handle */\n\n::-webkit-scrollbar-thumb {\n  background: #e3b5bb;\n  border-radius: 10px;\n}\n\n#WebSocket_component {\n  position: absolute;\n  z-index: 100;\n  right: 10px;\n  top: 11px;\n  width: 140px;\n  height: 30px;\n  border-radius: 6px;\n  text-align: center;\n  background-color: $pink_novita;\n  font-size: 15px;\n  padding-top: 6px;\n  font-family: \"mreaves-regular\";\n  a {\n    color: #fff;\n    text-decoration: none;\n  }\n}\n\n#AddFollowUp_component {\n  z-index: 100;\n  height: 30px;\n  border-radius: 6px;\n  text-align: center;\n  background-color: $pink_novita;\n  font-size: 15px;\n  padding-top: 6px;\n  font-family: \"mreaves-regular\";\n  a {\n    color: #fff;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
